/* eslint-disable no-undef */
/* eslint-disable no-constant-condition */
import _axios from 'axios'
import qs from 'qs'
import _this from '../main'
import common from './common'
import {
    dApiUrl,
    wApiUrl
} from './serviceUrl'

const axios = _axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
})
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
// 无session请求
export const nspost = (method, data, fun) => {
    data = data ? data : "";
    sendPost(dApiUrl + method, data, false, fun)
}
export const nspost2 = (method, data, fun) => {
    data = data ? data : "";
    sendPost(process.env.VUE_APP_BASE_API + method, data, false, fun)
}
// 普通nspste请求 无session
export const nspste = (method, data, fun) => {
    data = data ? data : "";
    sendPost(dApiUrl + method, data, false, fun)
}
// 普通post请求
export const post = (method, data, fun) => {
    // data = data?data:"";
    data.sessionID = common.getStorage("sessionID")
    sendPost(dApiUrl + method, data, false, fun)
}
// 微服务post请求
export const wPost = (method, data, fun) => {
    sendPost(wApiUrl + method, data, false, fun)
}
// 独立接口post请求
export const dPost = (method, data, fun) => {
    data = data ? data : "";
    if (common.getStorage("sessionID")) {
        if (method == 'searchMemberByPhone.json' || 'getActionList.json' || 'getStoryList.json') {//微信一键登录   查询用户手机号  不传sessionid

        } else {
            data.sessionID = common.getStorage("sessionID")
        }
    } else {
        // delete data.sessionID
        // delete data.memberID
    }
    // if (method == 'standardCreateOneMemberOrder.json') {
    //     if (common.getRecommendCode()) {
    //         data.recommendCode = getRecommendCode() || '';
    //         data.recommendMemberID = ''
    //     } else {
    //         data.recommendMemberID = common.getStorage("userInfo").recommendID || ''
    //         data.recommendCode = '';
    //     }
    // }
    if (method == 'submitOneAgainst.json') {
        data.siteID = common.siteID;
    }
    sendPost(dApiUrl + method, data, false, fun)
}
// 独立接口post请求 安卓
export const dPostAndroid = (method, domainName, data, fun) => {
    data = data ? data : "";
    if (common.getStorage("sessionID")) {
        if (method == 'searchMemberByPhone.json' || 'getActionList.json') {//微信一键登录   查询用户手机号  不传sessionid

        } else {
            data.sessionID = common.getStorage("sessionID")
        }
    } else {
        // delete data.sessionID
        // delete data.memberID
    }
    sendPost(domainName + '/interface-server/api/' + method, data, false, fun)
}

// axios 发送请求统一处理
export const sendPost = async (url, data, config, fun) => {
    if (url == 'interface-server/api/getCartGoodsList.json'||url == 'interface-server/api/addGoodsToCart.json') {
        data = {
            sessionID: window.localStorage.getItem("sessionID"),
            memberID: window.localStorage.getItem("memberID"),
            ...data,
        }
    } else {
        data = {
            siteID: common.siteID,
            // focusID: common.focusID,
            // sessionID: window.localStorage.getItem("sessionID"),
            // memberID: window.localStorage.getItem("memberID"),
            applicationID: common.applicationID,
            ...data,
        }
    }
    if (config) {
        // _this.$dialog.loading.open('上传中...')
    } else {
        data = data ? qs.stringify(data) : "";
    }
    try {
        const res = await axios({
            method: 'post',
            url,
            data,
            timeout: 150000
        })
        if (fun) fun(res)
        if (res.data.header.code === 10000) {
            let isWeiXin = common.isWeiXinBrowser()
            // 微信内 并且正式服
            if (isWeiXin) {
                common.removeStorage('sessionID')
                common.removeStorage('member')
                common.removeStorage('weixinToken')
                common.jumpToLoginWeiXin()
            } else {
                common.removeStorage('sessionID')
                common.removeStorage('member')
                common.removeStorage('weixinToken')
            }
        }
    } catch (err) {
        if (err) {
            if (err.response) {
                switch (err.response.status) {
                    case 400:
                        err.message = '请求参数错误'
                        break
                    case 401:
                        err.message = '未授权，请登录'
                        break
                    case 403:
                        err.message = '跨域拒绝访问'
                        break
                    case 404:
                        err.message = `请求地址出错: ${err.response.config.url}`
                        break
                    case 408:
                        err.message = '请求超时'
                        break
                    case 500:
                        err.message = '服务器内部错误'
                        break
                    case 501:
                        err.message = '服务未实现'
                        break
                    case 502:
                        err.message = '网关错误'
                        break
                    case 503:
                        err.message = '服务不可用'
                        break
                    case 504:
                        err.message = '网关超时'
                        break
                    case 505:
                        err.message = 'HTTP版本不受支持'
                        break
                    default:
                        break
                }

                // _this.$dialog.loading.close()
                common.errorToBack(err.message)
            }
            else {
                // common.errorToBack("请求超时，请重试。")
                //js判断手机操作系统(ios或者是Android)
                var u = navigator.userAgent
                //如果输出结果是true就判定是android终端或者uc浏览器
                var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1
                //根据输出结果true或者false来判断ios终端
                var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
                //!!双叹号一般用来将后面的表达式转换为布尔型的数据（boolean）
                if (isAndroid) {
                    // _this.$dialog.loading.close()
                } else if (isiOS) {
                    console.log("请求超时，请重试。")
                }

            }
        }
    }
}
//获得站点参数
export const getSiteParameterList = (data, callback) => dPost('getSiteParameterList.json', data, callback)
// 获取导航列表
export const getNavigatorList = (data, callback) => dPost('getNavigatorList.json', data, callback)
// 发送邮箱验证码
export const submitEmailBandingMember = (data, callback) => dPost('submitEmailBandingMember.json', data, callback)
// 获取轮播图
export const getFocusList = (data, callback) => dPost('getFocusPictureList.json', data, callback)
// 注册
export const memberPhoneRegister = (data, callback) => dPost('memberPhoneRegister.json', data, callback)
// 登陆
export const memberLogin = (data, callback) => dPost('memberLogin.json', data, callback)
// 短信验证码
export const sendSMSVerifyCode = (data, callback) => dPost('sendSMSVerifyCode.json', data, callback)
// 修改密码
export const setMemberPassword = (data, callback) => dPost('setMemberPassword.json', data, callback)
// 获取在线客服
export const getSiteServicerList = (data, callback) => dPost('getSiteServicerList.json', data, callback)
// 创建客服事件
export const submitOneServiceEvent = (data, callback) => dPost('submitOneServiceEvent.json', data, callback)
// 创建客服事件
export const applyOneShopSiteService = (data, callback) => dPost('applyOneShopSiteService.json', data, callback)
// 获取客服事件
export const getServiceEventList = (data, callback) => dPost('getServiceEventList.json', data, callback)
// 获取群聊
export const getMemberGroupList = (data, callback) => dPost('getMemberGroupList.json', data, callback)
// 修改群聊
export const updateOneMemberGroup = (data, callback) => dPost('updateOneMemberGroup.json', data, callback)
// 获取tome聊天记录
export const getToMeTalkingMessageList = (data, callback) => dPost('getToMeTalkingMessageList.json', data, callback)
// 获取meto聊天记录
export const getMeToTalkingMessageList = (data, callback) => dPost('getMeToTalkingMessageList.json', data, callback)
// 发送聊天
export const sendOneTalkMemberMessage = (data, callback) => dPost('sendOneTalkMemberMessage.json', data, callback)
// 获取会员详细信息
export const getOneMemberDetail = (data, callback) => dPost('getOneMemberDetail.json', data, callback)
// 绑定邮箱
export const applyEmailBindingMember = (data, callback) => dPost('applyEmailBindingMember.json', data, callback)
// 获取商品列表
export const getGoodsShopList = (data, callback) => dPost('getGoodsShopList.json', data, callback)
// 获取商品详情
export const getGoodsShopDetail = (data, callback) => dPost('getGoodsShopDetail.json', data, callback)
// 添加购物车
export const addGoodsToCart = (data, callback) => dPost('addGoodsToCart.json', data, callback)
// 删除购物车商品
export const deleteGoodsFromCart = (data, callback) => dPost('deleteGoodsFromCart.json', data, callback)
// 获取购物车列表
export const getCartGoodsList = (data, callback) => dPost('getCartGoodsList.json', data, callback)
// 创建订单
export const standardCreateOneMemberOrder = (data, callback) => dPost('standardCreateOneMemberOrder.json', data, callback)
//获取会员钱包
export const getMemberStatisticsWallet = (data, callback) => dPost('getMemberStatisticsWallet.json', data, callback)
// 获取文章列表
export const getNavigatorSimpleArticleList = (data, callback) => dPost('getNavigatorSimpleArticleList.json', data, callback)
// 获取文章详情
export const getArticleMoreDetail = (data, callback) => dPost('getArticleMoreDetail.json', data, callback)
// 获取会员订单组合列表
export const getMultiMemberOrderList = (data, callback) => dPost('getMultiMemberOrderList.json', data, callback)
// 获取企业会员订单列表
export const getMemberOrderList = (data, callback) => dPost('getMemberOrderList.json', data, callback)
// 获取企业会员订单详情
export const getOneMemberOrderDetail = (data, callback) => dPost('getOneMemberOrderDetail.json', data, callback)
// 获取会员订单商品列表
export const getMemberOrderGoodsList = (data, callback) => dPost('getMemberOrderGoodsList.json', data, callback)
// 微信支付生成二维码url
export const getWeiXinPayQrcodeURL = (data, callback) => dPost('getWeiXinPayQrcodeURL.json', data, callback)
//获取会员支付账户列表
export const getMemberPaywayList = (data, callback) => dPost('getMemberPaywayList.json', data, callback)
// 会员申请提现
export const applyOneMemberWithdraw = (data, callback) => dPost('applyOneMemberWithdraw.json', data, callback)
// 会员提现详情
export const getMemberWithdrawList = (data, callback) => dPost('getMemberWithdrawList.json', data, callback)
//添加Kas地址
export const createOneMemberPayway = (data, callback) => dPost('createOneMemberPayway.json', data, callback)
//删除Kas地址
export const deleteOneMemberPayway = (data, callback) => dPost('deleteOneMemberPayway.json', data, callback)
//获取推荐商品列表
export const getGoodsRecommendList = (data, callback) => dPost('getGoodsRecommendList.json', data, callback)
//取消撤回订单
export const cancelOneMemberOrder = (data, callback) => dPost('cancelOneMemberOrder.json', data, callback)
//隐藏订单--删除
export const hideOneMemberOrder = (data, callback) => dPost('hideOneMemberOrder.json', data, callback)
//查看订单是否支付成功
export const getMemberOrderPaySucccess = (data, callback) => dPost('getMemberOrderPaySucccess.json', data, callback)
//设置我的个人资料
export const updateMyMemberInfo = (data, callback) => dPost('updateMyMemberInfo.json', data, callback)
//刷新一个会员订单（优惠券变化）
export const refreshOneMemberOrder = (data, callback) => dPost('refreshOneMemberOrder.json', data, callback)
//修改一个企业会员订单
export const updateOneMemberOrder = (data, callback) => dPost('updateOneMemberOrder.json', data, callback)
// 获取购物车里面的商品总数量，总价钱，总类
export const getCartGoodsTotal = (data, callback) => dPost('getCartGoodsTotal.json', data, callback)
// 获取一条提现定义的详细信息
export const getOneWithdrawDefineDetail = (data, callback) => dPost('getOneWithdrawDefineDetail.json', data, callback)
// 线下付款给1个会员订单
export const offPaymentOneMemberOrder = (data, callback) => dPost('offPaymentOneMemberOrder.json', data, callback)
// 获取支付机构列表，useType=3
export const getPaywayList = (data, callback) => dPost('getPaywayList.json', data, callback)
// 勾选购物车商品
export const selectCartGoods = (data, callback) => dPost('selectCartGoods.json', data, callback)
// 修改商品数量在购物车
export const updateCartGoodsQTY = (data, callback) => dPost('updateCartGoodsQTY.json', data, callback)
// 金币变动列表
export const getGoldenBalanceList = (data, callback) => dPost('getGoldenBalanceList.json', data, callback)
export const getFocusPictureList = (data, callback) => dPost('getFocusPictureList.json', data, callback)


